<script setup lang="ts">
import { ref } from 'vue';

interface Props {
  size?: 'small' | 'medium' | 'large' | '2xlarge';
  image?: string | null;
  default?: string;
  type?: 'default' | 'bordered' | 'square';
}

const props = withDefaults(defineProps<Props>(), {
  size: 'small',
  image: null,
  default: (import.meta.env.PROD ? '' : 'https://ci.connx.com.au/staging/') + 'Images/no_photo.jpg',
  type: 'default',
});

const imageSource = ref(props.image ?? props.default);
</script>

<template>
  <button class="tw-p-0 tw-bg-transparent" :class="{
    'tw-rounded-full tw-overflow-hidden': type !== 'square',
    'tw-border-solid tw-border-connx-white': type === 'bordered',
    'tw-border-none': type !== 'bordered',
  }">
    <img :src="imageSource" :class="{
      'tw-w-[35px]': size === 'small',
      'tw-w-20': size === 'medium',
      'tw-w-28': size === 'large',
      'tw-w-36': size === '2xlarge',
    }">
  </button>
</template>
